import React from 'react';
import { Link } from 'react-router-dom';
import { IndustryCard } from '../../utils/industriesData';
import { useTranslation } from 'react-i18next';

type IndustriesGridProps = {
  items: IndustryCard[];
};

const IndustriesGrid: React.FC<IndustriesGridProps> = ({ items }) => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((item) => (
            <article
              key={item.id}
              className="group relative overflow-hidden rounded-2xl border border-[#E2E8F0] bg-gradient-to-b from-white to-[#F8FAFC] p-6 shadow-[0_10px_26px_rgba(15,23,42,0.06)] transition-all duration-300 hover:-translate-y-1 hover:border-teal-200 hover:shadow-[0_18px_36px_rgba(20,184,166,0.14)]"
            >
              <span className="pointer-events-none absolute inset-x-6 top-0 h-px bg-gradient-to-r from-transparent via-teal-300 to-transparent" />
              <div>
                <div className="flex items-center gap-3">
                  <div className="shrink-0 text-slate-700 transition-colors duration-300 group-hover:text-teal-700">
                    <item.icon className="h-5 w-5" />
                  </div>
                  <h3 className="text-lg font-bold text-[#0F172A] leading-tight">
                    {t(`industriesSection.items.${item.id}.title`, { defaultValue: item.title })}
                  </h3>
                </div>
                <p className="text-[#64748B] text-sm mt-3 leading-relaxed">
                  {t(`industriesSection.items.${item.id}.description`, { defaultValue: item.description })}
                </p>
              </div>

              <div className="mt-4 pt-4 border-t border-[#E2E8F0]">
                <p className="text-xs font-bold text-[#0F172A] uppercase tracking-[0.15em] mb-2">{t('industriesSection.keySolutionsLabel')}</p>
                <div className="flex flex-wrap gap-1.5">
                  {item.keySolutions.map((solution, solutionIndex) => (
                    <Link
                      key={`${item.id}-${solutionIndex}`}
                      to={solution.href}
                      className="text-[10px] bg-white text-[#64748B] px-2 py-1 rounded-md font-medium border border-[#E2E8F0] hover:text-teal-700 hover:border-teal-300 hover:bg-teal-50 transition-colors"
                    >
                      {t(`industriesSection.items.${item.id}.keySolutions.${solutionIndex}`, { defaultValue: solution.label })}
                    </Link>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesGrid;
